// src/utils/calculateTotal.ts
interface CartItem {
  price: number;
  quantity: number;
}

export const calculateTotal = (items: CartItem[]): number => {
  return items.reduce((total, item) => total + item.price * item.quantity, 0);
};